// API Endpoints Configuration
// Centralized endpoint definitions for better maintainability

export const API_ENDPOINTS = {
  // Salon endpoints
  SALON: {
    BY_DOMAIN: '/salon-by-domain',
  },
  
  // Franchise endpoints
  FRANCHISE: {
    STYLISTS: '/franchise/stylists',
    // Add more franchise endpoints here as needed
  },
  
  // Service endpoints
  SERVICE: {
    LIST: '/service',
    CREATE: '/service',
  },
  
  // Appointment/Booking endpoints
  APPOINTMENT: {
    CREATE: '/appointment',
    // LIST: '/appointment/list',
    // UPDATE: '/appointment/update',
    // DELETE: '/appointment/delete',
  },
} as const;

// Type for endpoint paths
export type ApiEndpoint = typeof API_ENDPOINTS;
